import { useRef } from 'react';

import { createForm } from '../createForm.js';
import type { FormApi } from '../form.types.js';

/**
 * Creates a stable `FormApi` for the lifetime of the component. The returned
 * handle is the same object on every render — equivalent to calling
 * `_createForm` once in a `useRef`.
 *
 * Pass it to the `form` prop of `<Form>` so you can call `form.submit()`,
 * `form.setError()`, etc. from anywhere in the tree.
 * @internal
 */
export function useForm<TValues = Record<string, unknown>>(): FormApi<TValues> {
  const ref = useRef<FormApi<TValues> | undefined>(undefined);
  if (ref.current === undefined) {
    ref.current = createForm<TValues>();
  }
  return ref.current;
}
